export default __webpack_public_path__ + "static/media/bonanza-ms.ca80f664.webp";